import React from 'react';
import './PolicyHegemonismDescription.css';
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  POLICY_HEGEMONISM_DISTANCE,
  POLICY_HEGEMONISM_MELEE_BONUS,
  POLICY_HEGEMONISM_QUARTER_WIN_POINTS_INCOME_BONUS,
  POLICY_HEGEMONISM_TEMPLE_WIN_POINTS_INCOME_BONUS
} from "../../../../configs/policy/hegemonism";
import {WinPointsStat} from "../../../PlayerStat/stats/WinPointsStat";

const PolicyHegemonismDescription = () => {
  const emptyHex = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/cell.png'}
    alt={'Пустая ячейка'}
    title={'Пустая ячейка (без строений и ключевых точек)'}
  />;

  const distance = <img
    className={'policy-description-icon'}
    src={'/img/icons/distance.png'}
    alt={'Дальность'}
    title={'Дальность'}
  />;

  const distanceValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={POLICY_HEGEMONISM_DISTANCE}
    icon={distance}
  />

  const quarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Базовый Квартал'}
    title={'Базовый Квартал'}
  />;

  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;

  const temple = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/temple.17c08b3d.png'}
    alt={'Храм'}
    title={'Храм'}
  />;

  const winPointsQuarter = <WinPointsStat
    text={POLICY_HEGEMONISM_QUARTER_WIN_POINTS_INCOME_BONUS}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const winPointsTemple = <WinPointsStat
    text={`+${POLICY_HEGEMONISM_TEMPLE_WIN_POINTS_INCOME_BONUS}`}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />

  const damageBonus = <span className={'text-war'}>
    {`+${POLICY_HEGEMONISM_MELEE_BONUS}`}
  </span>;

  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;

  const damageBonusValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damageBonus}
    icon={<>{damage}{melee}</>}
  />

  return (
    <>
      <div className={'policy-description_line'}>
        От центральной {emptyHex} на {distanceValueAndIcon}:
      </div>
      <div className={'policy-description_line policy-description_line-margin-top'}>
        • Доход {centralQuarter} {quarter} {winPointsQuarter},
      </div>
      <div className={'policy-description_line policy-description_line-margin-top'}>
        • Доход {temple} {winPointsTemple},
      </div>
      <div className={'policy-description_line policy-description_line-margin-top'}>
        • {unit} имеет {damageBonusValueAndIcon}.
      </div>
    </>
  );
};

export default PolicyHegemonismDescription;
